import { z } from 'zod'
import { formItemSchema } from './form-item'

export const selectSchema = formItemSchema.extend({
  type: z.literal('select'),
  allowClear: z.boolean().optional().describe('是否显示清除按钮'),
  virtual: z.boolean().optional().describe('是否开启虚拟滚动，数据量大时开启可以提高性能'),
  showSearch: z.boolean().optional().describe('是否可搜索'),
  width: z.string().default('100px').describe('宽度'),
  options: z
    .array(z.object({ label: z.string(), value: z.string() }))
    .optional()
    .describe('选项列表'),
  optionFilterProp: z.string().default('label').describe('搜索过滤字段'),
  source: z.string().optional().describe('数据源'),
})

export type SelectSchema = z.infer<typeof selectSchema>
